export const initAnchoredLinks = () => {
	document.querySelectorAll('[data-anchored-links]').forEach((nav) => {
		const links = nav.querySelectorAll('a')

		links.forEach((link) => {
			link.addEventListener('click', () => {
				links.forEach((item) => item.setAttribute('aria-current', 'false'))
				link.setAttribute('aria-current', 'true')
			})
		})
	})
}
